import Dropdown from "@components/atoms/Dropdown";
import { PRODUCT_SORT_LIST } from "@const/products.const";
import {
  ProductListMode,
  ProductSortBy,
} from "@interfaces/components/product-filters.interface";

interface Props {
  productListMode: ProductListMode;
  sortBy: ProductSortBy;
  onSortByChange: (sortBy: ProductSortBy) => void;
  onViewModeChange: (mode: ProductListMode) => void;
}

const Toolbar = ({
  productListMode,
  onViewModeChange,
  sortBy,
  onSortByChange,
}: Props) => {
  return (
    <div className="top-filter-menu d-flex align-items-center bg-white p-3 rounded-2">
      <a
        data-bs-toggle="offcanvas"
        href="#offcanvasFilters"
        className="text-filter"
      >
        <i className="icon icon-filter" />
        <span>FILTER</span>
      </a>
      {/* <a onClick={() => onViewModeChange('list')}>
        <i
          className={`icon icon-list ${
            productListMode === 'list' ? 'active' : ''
          }`}
        />
      </a> */}
      <a onClick={() => onViewModeChange("grid")}>
        <i
          className={`icon icon-grid ${
            productListMode === "grid" ? "active" : ""
          }`}
        />
      </a>
      <Dropdown
        selected={sortBy as string}
        options={PRODUCT_SORT_LIST}
        onChange={(value) => onSortByChange(value as ProductSortBy)}
      />
    </div>
  );
};

export default Toolbar;
